module.exports = __webpack_public_path__ + "img/account-user.459ca063.svg";